// fields to remove from systemHeader. Each field in the array will be removed
const fieldsToExclude = [
    'serverCreatedDate',
    'serverUpdatedDate',
    'previousVersionId'
];
export class SystemHeaderFilter {
    /**
     * remove any values from systemHeader that shouldn't be updated, as specified in
     * Mantis 10975: Do not overwrite values in systemHeader that aren't included in update
     * @param document the document
     */
    static filterSystemHeader(document) {
        if (document.systemHeader) {
            for (let i = 0; i < fieldsToExclude.length; i++) {
                delete document.systemHeader[fieldsToExclude[i]];
            }
        }
    }
    /**
     * When update or jsonPatchUpdate functions are called, only those values in
     * the update that are passed in as part of the systemHeader should be updated. Other values in
     * the systemHeader should not be removed or changed
     * Mantis 10975: Do not overwrite values in systemHeader that aren't included in update
     */
    static applyUpdatesToSystemHeader(origDoc, newDoc) {
        if (newDoc.systemHeader) {
            SystemHeaderFilter.filterSystemHeader(origDoc);
            SystemHeaderFilter.filterSystemHeader(newDoc);
            const updateKeys = Object.keys(newDoc.systemHeader);
            if (!origDoc.systemHeader) {
                origDoc.systemHeader = {};
            }
            for (let i = 0; i < updateKeys.length; i++) {
                const fieldName = updateKeys[i];
                const value = newDoc.systemHeader[fieldName];
                if (fieldName !== 'currentVersion') {
                    origDoc.systemHeader[fieldName] = value;
                }
            }
        }
    }
}
